import { render, staticRenderFns } from "./InlineAlert.vue?vue&type=template&id=05d2a7e2&scoped=true"
import script from "./InlineAlert.vue?vue&type=script&lang=js"
export * from "./InlineAlert.vue?vue&type=script&lang=js"
import style0 from "./InlineAlert.vue?vue&type=style&index=0&id=05d2a7e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d2a7e2",
  null
  
)

export default component.exports